// AI Productivity inner page — Defence Card 03.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function AiProductivity() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.aiTransformationConsultancy}
        eyebrow="Defence · AI Integration and Productivity"
        headline="AI that works at the"
        italicWord="coalface."
        lede="We embed practical AI tools into the daily operations of subcontractors so the compliance burden becomes lighter, not heavier."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Productivity and compliance, at the same time.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Most AI tools are built for office workers. We build AI for the people doing the
              actual work in defence supply chains. Scheduling, job tracking, compliance evidence
              capture, anomaly detection and supplier reporting.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              The goal is not to add more software. It is to remove manual steps that slow your
              team down and create compliance gaps that your prime can see.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              We start with your biggest time wasters.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We spend a week observing how your team works. We map the manual steps, the paper
              trails and the reporting obligations. We identify where AI can take those tasks off
              your team's plate.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              From there we build targeted tools, integrate them with your existing systems and
              train your team to use them. Most deployments are live within six weeks.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You are spending too much time on reporting and not enough on work.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have compliance and reporting obligations to a prime or a government agency that
              take hours every week. You want to give your prime visibility into your operations
              without creating a separate reporting job.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You are a growing subcontractor who wants to compete with larger businesses by being
              faster, more transparent and more reliable in your supply-chain communications.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
